<template>
    <div>
        <CRow>
            <CCol>
                <div style="width:100%; height: 75vh;">
                    <ejs-grid ref='gridrol' :dataSource='ricsLogsData' :allowFiltering='true' :allowPaging='true' :allowResizing='true'
                              :allowReordering='true' :allowSorting='true' :toolbar='toolbar':pageSettings='pageSettings' 
                              :filterSettings='filterOptions' :toolbarClick='toolbarClick' 
                              :actionBegin='actionBegin' :actionFailure="actionFailure" :actionComplete="actionComplete" 
                              :queryCellInfo='queryCellInfo' :excelQueryCellInfo='excelQueryCellInfo'
                              :allowExcelExport='true' :excelExportComplete='excelExportComplete' width="100%" height="100%">
                        <e-columns>
                            <e-column field='ricOtherInstrumentsLogId' headerText='Id' :isPrimaryKey='true' :visible='false'></e-column>
                            <e-column field='ricOtherInstrumentsId' headerText='Other Instrument Id' :visible='true' width=90></e-column>
                            <e-column field='core' headerText='Identifier' width=120></e-column>
                            <e-column field='utilityTypeName' headerText='Commodity' width=120 ></e-column>
                            <e-column field='periodTypeName' headerText='Period Type' width=120></e-column>
                            <e-column field='periodCodeType' headerText='Period Code Type' textAlign='Left' width=120></e-column>
                            <e-column field='description' headerText='Description' width=120></e-column>
                            <e-column field='logDate' headerText='Log Date' textAlign='Left' width=120 type="date" :format="dateFormatOptions"></e-column>
                            <e-column field='logTime' headerText='Log Time' textAlign='Left' type='string' width=150></e-column>
                            <e-column field='userName' headerText='User' textAlign='Left' width=150 type="string"></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </CCol>
        </CRow>
    </div>
</template>
<script>

    import Vue from "vue";
    import { GridPlugin, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport } from "@syncfusion/ej2-vue-grids";
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import gridOptions from '../../../common/gridOptions'
    import SyncHelper from '../../../common/syncfusion'
    import store from '../../../store';
    Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    export default {
        name: 'RICOther',
        data() {
            return {
                store: store,
                ricsLogsData: SyncHelper.getDataManager("RICOtherInstrumentsLog"),
                pageSettings: gridOptions.pageSettings,
                filterOptions: gridOptions.filterSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.RicOtherInstruments.Update"],
                    allowAdding: store.state.permissions["Permissions.RicOtherInstruments.Create"],
                    allowDeleting: store.state.permissions["Permissions.RicOtherInstruments.Delete"],
                    mode: 'Dialog'
                },
                toolbar: ['ExcelExport'],
                filterOptions: gridOptions.filterSettings,
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } }
            }
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            toolbarClick(args) {
                gridOptions.excelExport(args, "OtherRICs Logs.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.gridrol.hideSpinner();
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);
                if (args.requestType == 'refresh') {
                    hideSpinner(document.getElementById('mainSpinner'));
                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
            queryCellInfo(args) {
                if (args.column.field === 'logTime') {
                    args.cell.textContent = this.convertUTCDateToLocalTime(args.data['logDate']);
                }
                if (args.column.field === 'logDate') {
                    args.cell.textContent = this.convertUTCDateToLocaDate(args.data['logDate']);
                }
            },
            excelQueryCellInfo: function (args) {
                if (args.column.field === 'logTime') {
                    args.value = this.convertUTCDateToLocalTime(args.data['logDate']);
                }
                if (args.column.field === 'logDate') {
                    args.value = this.convertUTCDateToLocalTime(args.data['logDate']);
                }
            },
            convertUTCDateToLocalTime(dateString) {
                const date = new Date(dateString)
                var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
                return newDate.toLocaleTimeString();
            },
            convertUTCDateToLocaDate(dateString) {
                const date = new Date(dateString)
                var newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
                return newDate.toLocaleDateString();
            }
        },
        provide: {
            grid: [Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport]
        }
    }
</script>